import { injectable } from "inversify";
import { apiService, type PaginatedApiResponse } from "@/remote/api";
import type {
  MerchantApprovalDetailDto,
  MerchantApprovalItemDto,
  RejectMerchantRequestDto,
} from "../response/MerchantApprovalResponse";

export interface FetchMerchantApprovalsApiParams {
  page?: number;
  pageSize?: number;
  search?: string;
}

@injectable()
export class MerchantApprovalApiService {
  async fetchApprovals(
    params: FetchMerchantApprovalsApiParams = {},
  ): Promise<PaginatedApiResponse<MerchantApprovalItemDto>> {
    const { page = 1, pageSize = 10, search } = params;

    return apiService.getPaginated<MerchantApprovalItemDto>(
      "/product/api/v1/admin/merchants/approvals",
      {
        params: {
          page,
          pageSize,
          search: search || undefined,
        },
      },
    );
  }

  async fetchDetail(merchantId: string): Promise<MerchantApprovalDetailDto> {
    return apiService.getData<MerchantApprovalDetailDto>(
      `/product/api/v1/admin/merchants/${merchantId}/review`,
    );
  }

  async approveMerchant(merchantId: string): Promise<void> {
    await apiService.postData<Record<string, never>>(
      `/product/api/v1/admin/merchants/${merchantId}/approve`,
    );
  }

  async rejectMerchant(
    merchantId: string,
    payload: RejectMerchantRequestDto,
  ): Promise<void> {
    await apiService.postData<Record<string, never>, RejectMerchantRequestDto>(
      `/product/api/v1/admin/merchants/${merchantId}/reject`,
      payload,
    );
  }
}
